import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { lazyModalsNav } from 'app/app.navigation';
import { iconAssets } from 'core/icons/lib/icon-assets';
import { iconCloseRounded } from 'core/icons/lib/icon-close-rounded';
import { iconEllipsisH } from 'core/icons/lib/icon-ellipsis-h';
import { iconLock } from 'core/icons/lib/icon-lock';
import { iconMoneyChange } from 'core/icons/lib/icon-money-change';
import { iconOval } from 'core/icons/lib/icon-oval';
import { iconStar } from 'core/icons/lib/icon-start';
import { ModalRouter } from 'core/modules/modal';
import { CertificatePreviewModal, StreetPreviewModal } from 'dashboard/dashboard.navigation';
import { Building } from 'dashboard/models/building.model';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-building-item',
  templateUrl: './building-item.component.html',
  styleUrls: ['./building-item.component.scss'],
})
export class BuildingItemComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject();

  readonly ellipsisIcon = iconEllipsisH;
  readonly starIcon = iconStar;
  readonly cancelIcon = iconCloseRounded;
  readonly exchangeIcon = iconMoneyChange;
  readonly collectIcon = iconAssets;
  readonly spinIcon = iconOval;
  readonly lockEllipsis = iconLock;

  @Input()
  building: Building = new Building();

  @Output() emitTransfer = new EventEmitter<Building>();

  constructor(private modal: ModalRouter) {}

  @HostListener('click')
  openBuildingPreview(): void {
    this.openSellBuilding();
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  openTransferNFT(): void {
    this.emitTransfer.emit(this.building);
  }

  openWithdrawNFT(): void {
    this.modal.navigate(lazyModalsNav.dashboard.withdrawNFT(), undefined, {
      data: {
        entity: this.building,
        isBuilding: true
      } as StreetPreviewModal,
    });
  }

  openSellBuilding(): void {
    this.modal.navigate(lazyModalsNav.streets.buildingPreview(), undefined, {
      data: { entity: this.building, isBuilding: true, preserveQuery: true } as StreetPreviewModal,
    });
  }

  viewCertificate(): void {
    this.modal.navigate(lazyModalsNav.dashboard.certificatePreview(), undefined, {
      data: {
        nftId: this.building.nft.id.toString(),
      } as CertificatePreviewModal,
    });
  }
}
